import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative flex group rounded-xl w-full overflow-hidden" }
const _hoisted_2 = ["src"]


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenCard',
  props: ["token"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("img", {
      src: __props.token.image,
      alt: "# XXX",
      class: "block w-full aspect-square rounded-xl"
    }, null, 8, _hoisted_2)
  ]))
}
}

})